import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=f2b36036&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&lang=scss"
import style1 from "./Report.vue?vue&type=style&index=1&id=f2b36036&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b36036",
  null
  
)

export default component.exports